module.exports = "<dx-data-grid\r\n  id=\"gridContainer\"\r\n  [dataSource]=\"dataSource\" (onRowClick)=\"gridConfiguration.onRowClick.emit($event)\"\r\n></dx-data-grid>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/grid/grid.component.html
// module id = ../../../../../src/app/shared/grid/grid.component.html
// module chunks = main